export const EVENTS = {
  APP: {
    KILL_PURCHASE: {
      category: 'App',
      action: 'ClickAbandon',
      label: 'App_ClickAbandon',
    },
  },
  REDIRECT: {
    category: 'Redirect',
    action: 'View',
    label: 'Redirect_View',
  },
  REDIRECT_RESPONSE: {
    category: 'Redirect',
    action: 'Response',
    label: 'Redireccion',
  },
  OFFER: {
    VISIT: {
      category: 'Offer',
      action: 'View',
      label: 'Offer_View',
    },
    SELECT_OFFER: {
      OFFER_TYPE: {
        category: 'Offer',
        action: 'Click',
        label: 'Offer_type_Installments',
      },
    },
    EVENT: {
      category: 'Offer',
      action: 'Click',
      label: 'Offer_ClickContinue',
    },
  },
  REGISTER: {
    PHONE: {
      VISIT: {
        category: 'Register',
        action: 'View',
        label: 'Register_View',
      },
      REQUEST: {
        category: 'Register',
        action: 'Request',
        label: 'Registro_Telefono',
      },
      EVENT: {
        category: 'Register',
        action: 'Click',
        label: 'Register_ClickContinue',
      },
    },
    OTP: {
      VISIT: {
        category: 'Register',
        action: 'View',
        label: 'Register_ValidateOtp',
      },
      EVENT: {
        category: 'Register',
        action: 'Click',
        label: 'Register_ValidateOtp',
      },
      REQUEST: {
        category: 'Register',
        action: 'Request',
        label: 'Validacion_OTP',
      },
    },
  },
  PERSONAL_INFO: {
    VISIT: {
      category: 'PersonalInfo',
      action: 'View',
      label: 'PersonalInfo_View',
    },
    EVENT: {
      category: 'PersonalInfo',
      action: 'Click',
      label: 'ClickContinuar',
    },
  },
  KYC: {
    VISIT: {
      category: 'KYC',
      action: 'View',
      label: 'KYC_View',
    },
    ERROR: {
      category: 'KYC',
      action: 'View',
      label: 'KYC_ViewError',
    },
    REQUEST: {
      category: 'KYC',
      action: 'Request',
      label: 'Validacion_KYC',
    },
  },
  CREDIT: {
    VISIT: {
      category: 'Credit',
      action: 'View',
      label: 'Credit_View',
    },
    EVENT: {
      category: 'Credit',
      action: 'Click',
      label: 'Credit_ClickContinue',
    },
    REQUEST_PRELOAN: {
      category: 'Credit',
      action: 'Request',
      label: 'Preloan',
    },
    LEGAL: {
      category: 'Credit',
      action: 'Click',
      label: 'Credit_ClickCheck',
    },
  },
  LOAN: {
    REQUEST: {
      category: 'Loan',
      action: 'Request',
      label: 'Loan',
    },
  },
  PROMOTIONS: {
    REQUEST: {
      category: 'Promotions',
      action: 'Request',
      label: 'Promotions',
    },
  },
  CARD_REGISTER: {
    VISIT: {
      category: 'CardRegister',
      action: 'View',
      label: 'CardRegister_View',
    },
    EVENT: {
      category: 'CardRegister',
      action: 'Click',
      label: 'CardRegister_ClickContinue',
    },
    REQUEST: {
      category: 'CardRegister',
      action: 'Request',
      label: 'Tokenizacion',
    },
    REQUEST_CARD: {
      category: 'CardRegister',
      action: 'Request',
      label: 'Card',
    },
  },
  PAYMENTS: {
    REQUEST: {
      category: 'Payments',
      action: 'Request',
      label: 'Payments',
    },
  },
  PAYMENT_REJECTION: {
    VISIT: {
      category: 'PaymentRejection',
      action: 'View',
      label: 'PaymentRejection_View',
    },
  },
  PAYMENT_CONFIRMATION: {
    VISIT: {
      category: 'PaymentConfirmation',
      action: 'View',
      label: 'PaymentConfirmation_View',
    },
  },
};
